'use strict';

const { list } = require("angular-perfect-scrollbar-2");

module.exports = [
    "$uibModalInstance",
    "Department",
    "members","myDepartments", "$translate",
    function ($uibModal, Department, members,  myDepartments,$translate) {
    var _this = this;
    this.members = members;
    // console.log('llamado 9 myDepartments.get()')
    _this.myDepts= myDepartments.get();
        Department.find({
            filter:
            {
                "fields":["id"],
                "where": {
                    "id": "deptId"
                },
                "include": ["owners","tags"]
            }
        });
    const loadData = () => {
        Department.find({
            filter:
            {
                "where": { "id":{"inq":_this.myDepts.map(dept=>dept.id)}},
                "include": [
                    {
                        "relation": "owners",
                        "scope": {
                            "fields": ["firstName", "lastName", "id", "email"],
                            "include": [
                                "roles"
                            ]
                        }
                    },
                    {
                        "relation": "teams",
                        "scope": {
                            "fields": ["name", "id"],
                            "include": [
                                {
                                    "relation": "subscribedTo",
                                    "scope": {
                                        "fields": [
                                            "name", "id"
                                        ]
                                    }
                                },

                                {
                                    "relation": "teamMembers",
                                    "scope": {
                                        "include": [
                                            {
                                                "relation": "member",
                                                "scope": {
                                                    "include": ['clients']
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        })
            .$promise
            .then(function (depts) {
                processData(depts);
            });

    }

    var tooltipRenderer = function(params)
    {
        //console.log(params.colDef.headerName,params.value);
        if(params.value!=undefined)
            return '<span title="' + params.colDef.headerTooltip + '">'+ (params.value || '') +'</span>';
        return ''
    };

    const processData = (depts) => {
        let rows = [];
        let headers = [];
        depts.forEach((dept) => {
            const idyDept = headers.length;
            headers.push({ headerName: dept.name, children: [{ headerName: "(".concat(dept.name, ")"), field: dept.name, width: 100, headerClass: 'ag-header-DeptRole', cellClass: 'ag-header-DeptRole' }], headerClass: 'ag-header-group-cell-label', },);
            dept.teams.forEach(team => {
                let teamName = team.id//dept.name.concat("||", team.name);

                let subscribedTo = [];
                if(Array.isArray(team.subscribedTo))
                    subscribedTo=team.subscribedTo.reduce((list, form) => { list.push(form.name); return list }, [])
                headers[headers.length - 1].children.push({
                    headerName: team.name, field: teamName,
                    headerTooltip: ("Formularios suscriptos:\n>".concat(subscribedTo.join("\n>"))),
                    cellRenderer: tooltipRenderer,
                    enableTooltip: true});
                team.teamMembers.forEach(member => {
                    if (member.member) {
                        let idxUsuario = rows.findIndex(row => row["id"] == member.member.id);
                        if (idxUsuario == -1) {
                            idxUsuario = rows.length;
                            rows.push({ 'email': member.member.email, 'id': member.member.id, 'userName': member.member.firstName.concat(" ", member.member.lastName) });
                        }
                        rows[idxUsuario][teamName] = member.isTeamLeader ? "teamLeader" : "mobileUser";
                        if (rows[idxUsuario]["teamRol"] != "teamLeader" && member.isTeamLeader) {
                            rows[idxUsuario]["teamRol"] = "teamLeader";
                        }
                    }

                });
            });

            dept.owners.forEach(owner => {
                let idxUsuario = rows.findIndex(row => row["id"] == owner.id);
                if (idxUsuario == -1) {
                    idxUsuario = rows.length;
                    rows.push({ 'email': owner.email, 'id': owner.id, 'userName': owner.firstName.concat(" ", owner.lastName) });
                }
                if(!owner.roles)
                    console.log("Error usuario sin rol asignado:",owner.id,owner.email)
                rows[idxUsuario][dept.name] = owner.roles?.reduce((roleDept, role) => (role.name == "supervisor") ? role.name : roleDept, "owner");
                if (rows[idxUsuario]["deptRol"] != "owner") {
                    rows[idxUsuario]["deptRol"] = rows[idxUsuario][dept.name];
                }
            });
        });

        _this.members.forEach(member => {
            let idxUsuario = rows.findIndex(row => row["id"] == member.id);
            if (idxUsuario == -1) {
                idxUsuario = rows.length;
                rows.push({...member, 'email': member.email, 'id': member.id, 'userName': member.firstName.concat(" ", member.lastName)});
            }
            if (member.emailVerified != true)
                rows[idxUsuario]={...member,...rows[idxUsuario],"fieldAdmin": "INACTIVE"};
            else {
                rows[idxUsuario]={...member,...rows[idxUsuario],"fieldAdmin": member.roles.reduce((roleDept, role) => (role.name == "admin") ? role.name : roleDept, rows[idxUsuario]["deptRol"] || rows[idxUsuario]["teamRol"])};
            }
        });

        headers.forEach(header => {
            _this.columnDefs.push(header)
        })
        _this.gridOptions.api.setColumnDefs(_this.gridOptions.columnDefs);
        _this.gridOptions.api.setRowData(rows);
        //_this.gridOptions.api.sizeColumnsToFit()
    }

    this.columnDefs = [

        {
            headerName: "Usuario", children: [
                { headerName: "userId", field: "id", width: 100, hide: false },
                { headerName: "Nombre", sort: 'asc', pinned: 'left', field: "userName", width: 200 },
                { headerName: "Email", pinned: 'left', field: "email", width: 200 },
                { headerName: "ROL", pinned: 'left', field: "fieldAdmin", width: 80 },
                {
                  headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.CECO"),
                  field: "ceco",
                  width: 150,
                },
                {
                  headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.CLIENTS"),
                  field: "clients",
                  width: 150,
                  valueGetter: function (params) {
                    if (params.data.clients)
                      return params.data.clients.map((clt) => clt.name);
                    return "";
                  },
                 
                },
                {
                  headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.REGION"),
                  field: "region",
                  width: 150,
                },
                {
                  headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.OFFICE"),
                  field: "office",
                  width: 150,
                },
          
                {
                  headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.DEPARTMENT"),
                  field: "dept",
                  width: 150,
                },
                {
                  headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.TITLE"),
                  field: "title",
                  width: 150,
                },
                {
                  headerName: $translate.instant(
                    "DASHBOARD.DASH_USERS.COLS.EMPLOYEENUMBER"
                  ),
                  field: "employeeNumber",
                  width: 150,
                },
            ]
        }
    ];

    _this.gridOptions = {
        columnDefs: _this.columnDefs,
        enableFilter: true,
        enableSorting: true,
        showToolPanel: false,
        enableColResize: true,
        angularCompileRows: true,
        angularCompileFilters: true,
        angularCompileHeaders: true,
        groupHeaders: true,
        rowStyle: { background: 'white' },
        getRowStyle: params => {
            if (params.node.id % 2 === 0) {
                return { background: '#f6f9fb' };
            }
        },
        rowHeight: 40,
        rowSelection: 'multiple',
        onCellDoubleClicked: function (e) {
            console.log(e);
        },
        onGridReady: function (grid) {
            grid.api.setHeaderHeight(40);
        },
    };

    _this.downloadCSV = function () {
        _this.gridOptions.api.exportDataAsCsv({
            fileName: "UserPermissions.csv"
        });
    }

    _this.downloadXLSX = function () {
        if (_this.gridOptions.api) {
            window.exportarAgGridAExcel(_this.gridOptions.api, "UserPermissions.xlsx");
        }
    }

    loadData();

}];
